import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import CustomAppBar from "./appBar";
import TopBar from "./TopBar";
import CustomDrawer from "./drawer";
import { connect, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { OrganizationThemeState } from "../../context/OrganizationThemeContext";
import icar_logo from "../../images/icar.png";
import AccountCircle from "@material-ui/icons/AccountCircle";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: "flex",
    minHeight: "100vh",
    overflow: "hidden",
    width: "100%",
  },
  attemptwrap: {
    paddingRight: "24px !important",
    paddingLeft: "24px !important",
    paddingTop: "112px !important",
  },
  wrapper: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
    position: "relative",
    paddingTop: 83,
    [theme.breakpoints.up("lg")]: {
      paddingLeft: 256,
    },
    "&::before": {
      // content: '""',
      // display: 'block',
      // height: '260px',
      // width: '330px',
      // top: '0px',
      // right: '0px',
      // position: 'absolute',
      // backgroundImage: 'url(top-right.png)',
      // backgroundSize : 'cover',
      // zIndex : '-1'
    },
    "&::after": {
      // content: '""',
      // display: 'block',
      // height: '260px',
      // width: '330px',
      // bottom: '0px',
      // left: '256px',
      // position: 'absolute',
      // backgroundImage: 'url(bottom-left.png)',
      // backgroundSize : 'cover',
      // zIndex : '-1'
    },
  },
  contentContainer: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
  },
  content: {
    flex: "1 1 auto",
    height: "100%",
    overflow: "hidden",
  },
  resplogo03: {
    padding: "15px 15px 20px",
    position: "absolute",
    objectFit: "contain",
    borderBottom: "none",
  },
  profileicon: {
    objectFit: "cover",
    borderRadius: "50%",
    width: "25px",
    height: "25px",
  },
  profilewrap: {
    position: "absolute",
    top: "30px",
    right: "24px",
    display: "flex",
    alignItems: "center",
    flexDirection: "row-reverse",
    gap: "10px",
  },
}));

function Menu(props) {
  const { children, session } = props;
  const { themeLogin } = OrganizationThemeState();
  const editDatas =
    useSelector((state) => state.uuidThemeReducer.uuidThemeValue) || "";
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const token = localStorage.getItem("token");

  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  const location = useLocation();
  const pathname = location.pathname;
  return (
    <div className={classes.root}>
      <CssBaseline />
      {pathname !== "/assessment/start" && !editDatas ? (
        <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
      ) : (
        <div>
          <img
            src={themeLogin?.logo || icar_logo}
            className={`${classes.resplogo03} logo__wrapper`}
          />
          <div className={classes.profilewrap}>
            {session?.profile?.file_name?.length ? (
              <img
                src={session?.profile?.file_name}
                alt="session?.profile?.file_name"
                className={classes.profileicon}
              ></img>
            ) : (
              <AccountCircle />
            )}
            <span>{session?.fullname}</span>
          </div>
        </div>
      )}
      {pathname !== "/assessment/start" && !editDatas ? (
        <CustomDrawer
          onMobileClose={() => setMobileNavOpen(false)}
          openMobile={isMobileNavOpen}
        />
      ) : (
        ""
      )}
      <div
        className={`${classes.wrapper} ${
          pathname == "/assessment/start" || editDatas
            ? classes.attemptwrap
            : ""
        }`}
      >
        <div className={classes.contentContainer}>
          <div className={classes.content}>{children}</div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  session: state.session,
});

export default connect(mapStateToProps, null)(withRouter(Menu));
